"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const react_1 = __importStar(require("react"));
const theme_1 = require("../../styles/theme");
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const RepeatFieldWrapperWeb_1 = require("./RepeatFieldWrapperWeb");
const RepeatWrapperWeb_1 = require("./RepeatWrapperWeb");
const GroupWrapperWeb = props => {
    const classes = useStyles();
    const { children, controlDefinition, onRemoveClick, repeatCount, repeatable, isOriginal, translateFunction = text => text } = props, moreProps = __rest(props, ["children", "controlDefinition", "onRemoveClick", "repeatCount", "repeatable", "isOriginal", "translateFunction"]);
    const { openDeleteConfirmation } = (0, RepeatWrapperWeb_1.useRepeatWrapperContext)();
    const handleRemoveClick = () => {
        onRemoveClick && onRemoveClick();
    };
    const canDelete = (0, react_1.useCallback)(() => {
        if (isOriginal && !(0, FormRendererHelpers_1.getAllowInitialDataDelete)(controlDefinition)) {
            return false;
        }
        return repeatCount > (0, FormRendererHelpers_1.getRepeatMin)(controlDefinition) && repeatable;
    }, [repeatCount, controlDefinition, repeatable, isOriginal]);
    const onDelete = (0, react_1.useCallback)((evt) => {
        evt.stopPropagation();
        openDeleteConfirmation(handleRemoveClick, (0, FormRendererHelpers_1.getDeleteConfirmationMessage)(controlDefinition));
    }, [controlDefinition]);
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(core_1.Accordion, { defaultExpanded: true, className: classes.wrapper },
            react_1.default.createElement(core_1.AccordionSummary, { expandIcon: react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "6", viewBox: "0 0 10 6", fill: "none" },
                    react_1.default.createElement("path", { d: "M0 0.5L5 5.5L10 0.5L0 0.5Z", fill: "black", fillOpacity: "0.54" })), style: styles.expandIcon, className: classes.acSummary },
                react_1.default.createElement(core_1.Typography, { className: classes.label, style: styles.labelTxt }, translateFunction(controlDefinition.label)),
                canDelete() && (react_1.default.createElement(core_1.Button, { size: 'small', className: classes.delete, variant: 'text', onClick: onDelete }, translateFunction('Delete')))),
            react_1.default.createElement(core_1.AccordionDetails, { className: classes.AccordionDetail },
                react_1.default.createElement("div", { className: classes.fieldWrapper }, children)),
            repeatable && react_1.default.createElement(RepeatFieldWrapperWeb_1.InstanceFooters, Object.assign({}, props)))));
};
const styles = {
    expandIcon: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        gap: 8,
    },
    labelTxt: { marginLeft: '12px' },
};
const useStyles = (0, styles_1.makeStyles)(theme => ({
    container: {
        position: 'relative',
        marginTop: 10,
        marginBottom: 10,
    },
    wrapper: {
        width: '100%',
        boxShadow: `none`,
        border: `1px solid ${theme_1.colors.black10}`,
        borderRadius: '5px !important',
    },
    acSummary: {
        background: theme_1.colors.flashWhite,
        padding: '10px 20px',
        minHeight: '18px !important',
        display: 'flex',
        alignItems: 'center',
        '& .MuiAccordionSummary-content': {
            margin: 0,
        },
        '& .MuiIconButton-root': {
            padding: 0,
        },
        '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: 42,
        },
    },
    fieldWrapper: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 10,
        padding: '18px 20px',
    },
    connector: {
        backgroundColor: theme_1.colors.grayPlaceholder,
        height: 50,
        width: 10,
        position: 'absolute',
        bottom: -33,
        right: 15,
    },
    AccordionDetail: {
        padding: '0px',
    },
    label: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: 15,
        fontWeight: 400,
        color: theme_1.colors.black0,
    },
    delete: {
        color: theme_1.colors.darkRed,
        padding: 0,
        display: 'flex',
        justifyContent: 'end',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: 'normal',
        textTransform: 'capitalize',
        minWidth: 0,
        '&:hover': {
            background: 'none',
        },
    },
}));
exports.default = GroupWrapperWeb;
//# sourceMappingURL=GroupWrapperWeb.js.map